export const seriesInputs = {
    date: [],
    number: [],
    string: [],
    boolean: [],
  };
  